













import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { controllistTableMap } from '@/common/constant.js';

@Component({
  components: {}
})
class ControllistBitableReport extends Vue {
  controllistTable: string = '';

  created() {
    this.controllistTable = controllistTableMap[window.location.host];
  }
}
export default ControllistBitableReport;
